import React from 'react';
import type RoadmapViewClassicType from '@atlassian/jira-spa-apps-roadmap/src/view/classic/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */
export const LazyRoadmapViewClassic = lazyForPaint<typeof RoadmapViewClassicType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-classic-roadmap", jiraSpaEntry: "async-classic-roadmap" */ '@atlassian/jira-spa-apps-roadmap/src/view/classic/index-old.tsx'
		),
	),
);

/** @deprecated Use entrypoint roadmapViewClassicPageEntrypoint */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ match }: RouteContext) => {
	const { boardId } = match.params;
	return (
		<LazyPage
			Page={LazyRoadmapViewClassic}
			pageId={`classic-roadmap-${boardId || ''}`}
			shouldShowSpinner={false}
		/>
	);
};
